import axios from '@/lib/axios';
import { PurchaseOrderAccounting } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0730. 発注案件管理会計登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_accountings
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  year_month: string;
  monthly_amount?: number;
  spot_amount?: number;
};
const createPurchaseOrderAccounting = (props: Props): Promise<PurchaseOrderAccounting> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_accountings`, props);
};

export const useCreatePurchaseOrderAccounting = () => {
  return useMutation({
    mutationFn: createPurchaseOrderAccounting,
  });
};
